/*************************************************/
/* TOPANNOUNCEMENTBANNER                         */
/*************************************************/

export function topAnnouncementBanner() {
  const topAnnouncementBanner = document.querySelector(".top-announcement-banner");
  const closeTopAnnouncementBanner = document.querySelector(".top-announcement-banner__close");
  const visibleClass = "top-announcement-banner--visible";

  // Get the root element to update the CSS variable
  const root = document.documentElement;

  // Function to determine and set the appropriate header height based on screen size and announcement height
  const setHeaderHeight = (isAnnouncementVisible) => {
    const announcementHeight = isAnnouncementVisible ? topAnnouncementBanner.offsetHeight : 0; // Get dynamic announcement height
    let baseHeaderHeight;

    // Use media queries to determine the base header height
    if (window.matchMedia("(min-width: 992px)").matches) {
      baseHeaderHeight = 110; // Larger screens
    } else {
      baseHeaderHeight = 80; // Smaller screens
    }

    const totalHeight = baseHeaderHeight + announcementHeight; // Calculate total header height

    // Set CSS variable with dynamic height
    root.style.setProperty('--header-height', `${totalHeight}px`);
  };

  // Function to hide the announcement and update the CSS variable
  const hideTopAnnouncementBanner = () => {
    topAnnouncementBanner.classList.remove(visibleClass);  // Hide the announcement
    setHeaderHeight(false);  // Adjust header height for hidden announcement
    sessionStorage.setItem("topAnnouncementBannerHidden", "true");  // Save the hidden state
  };

  const init = () => {
    if (!topAnnouncementBanner || !closeTopAnnouncementBanner) return; // Ensure the elements exist

    // Check sessionStorage to see if the announcement should be shown or hidden
    const announcementVisible = sessionStorage.getItem("topAnnouncementBannerHidden") !== "true";
    if (announcementVisible) {
      // Show the announcement if it hasn't been hidden yet in the session
      topAnnouncementBanner.classList.add(visibleClass);
    }

    // Set the initial header height based on screen size and announcement visibility
    setHeaderHeight(announcementVisible);

    // Attach the click event listener to the close button
    closeTopAnnouncementBanner.addEventListener("click", hideTopAnnouncementBanner);

    // Update the header height on window resize
    window.addEventListener('resize', () => {
      setHeaderHeight(topAnnouncementBanner.classList.contains(visibleClass));
    });
  };

  init();
}

